import { React } from 'react'
import ProdAdvString from '../blocks/ProdAdvString'

export default function ProdAdv() {

    return (
        <div className="adv-container container">
            <ul className="adv-list list-reset">
                <ProdAdvString title={"Команда профессионалов"} dscr={"Команда Medguru имеет большой опыт на ТВ-проектах, в рекламе и индустрии видеоклипов (93 минуты с окончания съемки до финального ролика)"}/>
                <ProdAdvString title={"Полный цикл видеопроизводства"} dscr={"Препродакшн, продакшн, постпродакшн (подключение на этапе разработки видео, написание сценариев разной степени сложности)"} />
                <ProdAdvString title={"Собственные мобильные студии"} dscr={"Мы располагаем собственными мобильными студиями под разные цели и задачи (567 мероприятий наша команда провела за 2023 год)"}/>
                <ProdAdvString title={"Cовременное оборудование"} dscr={"Собственный парк современного оборудования, специально предназначенного для создания качественного контента"}/>
            </ul>
        </div>
  )
}
